/**
 * Compound version stamped into the bundle at build time. The backend's
 * `/healthz` returns the same shape; a mismatch surfaces as a banner in the
 * cockpit sidebar version block. The raw values come from `VITE_BUILD_ID` +
 * `package.json#version`; we fall back to the literal `local` when the env
 * var is absent (Azure Pipelines sets `BUILD_ID=ado-<Build.BuildNumber>`).
 */
const semver = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.0.0';
const buildId = (import.meta.env.VITE_BUILD_ID as string | undefined) ?? 'local';

export const cockpitVersion = {
  semver,
  buildId,
  compound: `${semver}+${buildId}`,
} as const;
